import { Loader2 } from "lucide-react";
import { useCustomerAuth } from "@/context/CustomerAuthContext";

export default function CustomerProtectedRoute({ children }) {
  const { customer, startLogin } = useCustomerAuth();

  if (customer === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white" data-testid="customer-auth-checking">
        <Loader2 className="w-8 h-8 text-brand-red animate-spin" />
      </div>
    );
  }

  if (!customer) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-white px-6 text-center" data-testid="customer-login-gate">
        <h1 className="font-display text-4xl">Sign in to your account</h1>
        <p className="mt-3 font-serif text-lg text-brand-ink/60 max-w-md">See your upcoming sessions and remaining pack credits.</p>
        <button onClick={startLogin} className="mt-8 px-8 py-4 rounded-full bg-brand-red text-white font-medium hover:bg-brand-reddark transition-colors" data-testid="google-signin-btn">Continue with Google</button>
      </div>
    );
  }

  return children;
}
